/* Pan & Plus — Shopify theme scripts (vanilla JS, no framework) */
(function () {
  "use strict";

  /* ---------------- Mobile nav ---------------- */
  var toggle = document.querySelector(".nav-toggle");
  var nav = document.querySelector(".main-nav");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      var isOpen = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
    nav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        nav.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      });
    });
  }

  /* ---------------- Product gallery thumbnail swap ---------------- */
  var mainImg = document.querySelector("[data-gallery-main]");
  var thumbs = document.querySelectorAll("[data-gallery-thumb]");
  if (mainImg && thumbs.length) {
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        mainImg.src = btn.getAttribute("data-full");
        mainImg.alt = btn.getAttribute("data-alt") || "";
        thumbs.forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
      });
    });
  }

  /* ---------------- Footer year ---------------- */
  var yearEl = document.querySelector("#current-year");
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  /* ================================================================
     CART — AJAX (Shopify /cart.js, /cart/add.js, /cart/change.js)
     ================================================================ */
  var CartAPI = {
    get: function () {
      return fetch("/cart.js").then(function (r) { return r.json(); });
    },
    add: function (id, quantity) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: quantity }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    },
    changeLine: function (line, quantity) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); });
    }
  };

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (format) return format.replace(/\{\{\s*amount\s*\}\}/, value);
    return "$" + value;
  }

  var moneyFormat = (window.themeMoneyFormat || "${{amount}}");

  var cartDrawer = document.querySelector("[data-cart-drawer]");
  var cartOverlay = document.querySelector("[data-cart-overlay]");
  var cartBody = document.querySelector("[data-cart-body]");
  var cartSubtotal = document.querySelector("[data-cart-subtotal]");
  var cartCountEls = document.querySelectorAll("[data-cart-count]");

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add("is-open");
    if (cartOverlay) cartOverlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove("is-open");
    if (cartOverlay) cartOverlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  document.querySelectorAll("[data-cart-open]").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      renderCart();
      openCartDrawer();
    });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (el) {
    el.addEventListener("click", closeCartDrawer);
  });
  if (cartOverlay) cartOverlay.addEventListener("click", closeCartDrawer);

  function renderCart() {
    if (!cartBody) return;
    CartAPI.get().then(function (cart) {
      updateCartCount(cart.item_count);
      if (!cart.items.length) {
        cartBody.innerHTML = '<p class="cart-empty-msg">Your cart is empty.</p>';
        if (cartSubtotal) cartSubtotal.textContent = "";
        return;
      }
      var html = "";
      cart.items.forEach(function (item, idx) {
        html += '<div class="cart-line" data-line="' + (idx + 1) + '">' +
          '<img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy">' +
          '<div>' +
            '<div class="cart-line-title">' + item.product_title + '</div>' +
            '<div class="cart-line-qty-row">' +
              '<button type="button" data-qty-decrease>&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-increase>+</button>' +
            '</div>' +
            '<button type="button" class="cart-line-remove" data-qty-remove>Remove</button>' +
          '</div>' +
          '<div class="cart-line-price">' +
            (item.original_line_price > item.final_line_price ? '<span class="cart-original-price">' + formatMoney(item.original_line_price, moneyFormat) + '</span>' : '') +
            '<span>' + formatMoney(item.final_line_price, moneyFormat) + '</span>' +
            (item.discount_allocations && item.discount_allocations.length ? '<small class="cart-discount-note">' + item.discount_allocations.map(function(d){ return d.discount_application && d.discount_application.title ? d.discount_application.title : 'Discount applied'; }).join(' · ') + '</small>' : '') +
          '</div>' +
        '</div>';
      });
      cartBody.innerHTML = html;
      if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price, moneyFormat);

      cartBody.querySelectorAll("[data-line]").forEach(function (lineEl) {
        var line = parseInt(lineEl.getAttribute("data-line"), 10);
        var qtySpan = lineEl.querySelector(".cart-line-qty-row span");
        var currentQty = parseInt(qtySpan.textContent, 10);

        var incBtn = lineEl.querySelector("[data-qty-increase]");
        var decBtn = lineEl.querySelector("[data-qty-decrease]");
        var rmBtn = lineEl.querySelector("[data-qty-remove]");

        if (incBtn) incBtn.addEventListener("click", function () {
          CartAPI.changeLine(line, currentQty + 1).then(renderCart);
        });
        if (decBtn) decBtn.addEventListener("click", function () {
          var next = currentQty - 1;
          CartAPI.changeLine(line, next).then(renderCart);
        });
        if (rmBtn) rmBtn.addEventListener("click", function () {
          CartAPI.changeLine(line, 0).then(renderCart);
        });
      });
    });
  }

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* Initial cart count on page load */
  CartAPI.get().then(function (cart) { updateCartCount(cart.item_count); }).catch(function () {});

  /* ---------------- Product form: quantity selector + add to cart ---------------- */
  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var qtyInput = form.querySelector("[data-qty-input]");
    var incBtn = form.querySelector("[data-qty-inc]");
    var decBtn = form.querySelector("[data-qty-dec]");
    var addBtn = form.querySelector("[data-add-to-cart]");
    var feedback = form.querySelector("[data-add-feedback]");
    var variantId = form.querySelector("[data-variant-id]");

    function clampQty() {
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      qtyInput.value = v;
      return v;
    }

    if (incBtn) incBtn.addEventListener("click", function () {
      qtyInput.value = clampQty() + 1;
    });
    if (decBtn) decBtn.addEventListener("click", function () {
      qtyInput.value = Math.max(1, clampQty() - 1);
    });
    if (qtyInput) qtyInput.addEventListener("change", clampQty);

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!variantId) return;
      var qty = clampQty();
      addBtn.disabled = true;
      addBtn.textContent = "Adding\u2026";
      feedback.textContent = "";
      feedback.classList.remove("is-success");

      CartAPI.add(variantId.value, qty)
        .then(function () {
          feedback.textContent = "Added to cart.";
          feedback.classList.add("is-success");
          renderCart();
          openCartDrawer();
        })
        .catch(function (err) {
          feedback.textContent = (err && err.description) || "Could not add this item right now.";
        })
        .finally(function () {
          addBtn.disabled = false;
          addBtn.textContent = "Add to cart";
        });
    });
  });

  /* Escape key closes cart drawer */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeCartDrawer();
  });
})();
